var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReuser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 12619"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#185edf",
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.333 8a7.333 7.333 0 0 1-13.9 3.234.664.664 0 1 1 1.167-.633 6 6 0 1 0 .933-6.6h1.766a.7.7 0 0 1 .7.567.667.667 0 0 1-.666.766H1.999a.667.667 0 0 1-.666-.667v-3.3a.7.7 0 0 1 .567-.7.667.667 0 0 1 .767.667v1.633A7.333 7.333 0 0 1 15.333 8z",
    "data-name": "Path 16764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 10.667a.567.567 0 0 1-.333-.1l-3.667-2.2v-3.7a.667.667 0 1 1 1.333 0v2.967l3 1.8a.664.664 0 0 1-.333 1.233z",
    "data-name": "Path 16765"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuser);
export default __webpack_public_path__ + "static/media/Reuser.c077b6f98aaf6eb90665fabe7d8b23ef.svg";
export { ForwardRef as ReactComponent };